import cn from "classnames";
import BookForm from "components/shared/book/form";
import { Field, Select } from "components/shared/form";
import Loader from "components/shared/loader";
import { driverSalaryMileageTypesEnum } from "helpers/enums";
import { serializeReq, validateForm } from "helpers/form";
import { ymEvent } from "helpers/system";
import { requiredField } from "helpers/validators";
import cloneDeep from "lodash/cloneDeep";
import isEqual from "lodash/isEqual";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { apply, applyIndividualPrize, getOptions } from "sources/books/driverSalary";
import { config, initialState } from "./formConfig";

class Form extends BookForm {
    get periodFormatted() {
        const { year, month } = this.props.period;

        return `${year}-${month}-01T00:00:00.00Z`;
    }

    isValidForm = (state) => {
        const copyConfig = { ...this.props.config };

        if (state.mileageType === driverSalaryMileageTypesEnum.ActiveAndEmpty) {
            copyConfig.secondaryRate = { ...config.secondaryRate, validators: [requiredField], required: true };
        }

        return validateForm(copyConfig, serializeReq(state));
    };

    applyReq = async (serialized) => {
        const { initialState, refetch } = this.props;

        const serializedFormatted = {
            period: this.periodFormatted,
        };

        const detarpingPrizesIsChanged = !isEqual(initialState.detarpingPrizes, serialized.detarpingPrizes);
        const individualPrizesIsChanged = !isEqual(initialState.individualPrizes, serialized.individualPrizes);
        const driverIndividualPrizesIsChanged = !isEqual(
            initialState.driverIndividualPrizes,
            serialized.driverIndividualPrizes,
        );

        // если изменилось хоть одно поле из baseValues, то передаем все поля
        if (
            String(initialState.baseSalary) !== String(serialized.baseSalary) ||
            String(initialState.mileageType) !== String(serialized.mileageType) ||
            String(initialState.rate) !== String(serialized.rate) ||
            String(initialState.secondaryRate) !== String(serialized.secondaryRate) ||
            String(initialState.lowMileageMultiplier) !== String(serialized.lowMileageMultiplier) ||
            String(initialState.lowMileageThreshold) !== String(serialized.lowMileageThreshold) ||
            String(initialState.dailyIncome) !== String(serialized.dailyIncome) ||
            String(initialState.travelDailyIncome) !== String(serialized.travelDailyIncome) ||
            String(initialState.interBidsIdleCost) !== String(serialized.interBidsIdleCost) ||
            String(initialState.loadIdleCost) !== String(serialized.loadIdleCost) ||
            String(initialState.unloadIdleCost) !== String(serialized.unloadIdleCost)
        ) {
            serializedFormatted.baseValues = {};

            serializedFormatted.baseValues.baseSalary = serialized.baseSalary;
            serializedFormatted.baseValues.mileageType = serialized.mileageType;
            serializedFormatted.baseValues.rate = serialized.rate;

            if (serialized.mileageType === driverSalaryMileageTypesEnum.ActiveAndEmpty) {
                serializedFormatted.baseValues.secondaryRate = serialized.secondaryRate;
            }

            serializedFormatted.baseValues.lowMileageMultiplier = serialized.lowMileageMultiplier;
            // если значение пустое, serializeReq не добавляет в результат это поле, serialized.lowMileageThreshold будет undefined
            serializedFormatted.baseValues.lowMileageThreshold = serialized.lowMileageThreshold ?? "";
            serializedFormatted.baseValues.dailyIncome = serialized.dailyIncome;
            serializedFormatted.baseValues.travelDailyIncome = serialized.travelDailyIncome;
            serializedFormatted.baseValues.interBidsIdleCost = serialized.interBidsIdleCost;
            serializedFormatted.baseValues.loadIdleCost = serialized.loadIdleCost;
            serializedFormatted.baseValues.unloadIdleCost = serialized.unloadIdleCost;
        }

        if (detarpingPrizesIsChanged) {
            serializedFormatted.detarpingPrizes = serialized.detarpingPrizes;
        }

        if (individualPrizesIsChanged) {
            serializedFormatted.individualPrizes = serialized.individualPrizes;
        }

        if (driverIndividualPrizesIsChanged) {
            serializedFormatted.driverIndividualPrizes = serialized.driverIndividualPrizes;
        }

        ymEvent("SaveSalarySettings");
        const response = await apply(serializedFormatted);

        if (response) {
            refetch();

            this.close();
        } else {
            this.setState({ isLoading: false, isValid: false });
        }
    };

    renderField = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        return (
            <Field
                key={props.inputProps.name}
                onChange={this.setValue}
                value={this.value(props.inputProps.name)}
                {...props}
            />
        );
    };

    renderSelect = (props) => {
        if (!props || !props.inputProps) {
            return null;
        }
        const defProps = {
            key: props.inputProps.name,
            wrapper: "book-field",
            onChange: this.setValue,
            value: this.value(props.inputProps.name),
        };
        const { key, ...selectProps } = { ...defProps, ...props };
        return <Select {...selectProps} key={key} />;
    };

    renderDetarpingPrizes = () => {
        const { config } = this.props;
        const { detarpingPrizes } = this.state;

        const handleFieldChange = (name, value, index) => {
            const copyDetarpingPrizes = detarpingPrizes.map((item, i) =>
                i === index ? { ...item, [name]: value } : item,
            );

            this.setState({ detarpingPrizes: copyDetarpingPrizes });
        };

        const handleAddDetarpingPrize = () => {
            this.setState({ detarpingPrizes: [...detarpingPrizes, { loadUnloadTypeId: null, prize: null }] });
        };

        const handleDeleteDetarpingPrize = (index) => {
            const copyDetarpingPrizes = cloneDeep(detarpingPrizes);

            copyDetarpingPrizes.splice(index, 1);

            this.setState({ detarpingPrizes: copyDetarpingPrizes });
        };

        return (
            <div className="row form-group">
                <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                    {config.detarpingPrizes.label}
                </label>
                <div className="col-sm-8 col-md-9 col-form-label col-form-label-sm">
                    {detarpingPrizes.map((el, index) => {
                        return (
                            <div key={index}>
                                <div className="form-group text-muted">Надбавка за растентовки №{index + 1}</div>
                                {this.renderSelect({
                                    ...config.detarpingPrizes.config.loadUnloadTypeId,
                                    options: this.props.enums.loadUnloadType.filter((type) => {
                                        if (el.loadUnloadTypeId === type.value) {
                                            return true;
                                        }
                                        if (
                                            detarpingPrizes.some(
                                                (detarpingPrize) => detarpingPrize.loadUnloadTypeId === type.value,
                                            )
                                        ) {
                                            return false;
                                        }
                                        return true;
                                    }),
                                    onChange: ({ name, value }) => handleFieldChange(name, value, index),
                                    value: el.loadUnloadTypeId,
                                })}
                                {this.renderField({
                                    ...config.detarpingPrizes.config.prize,
                                    onChange: ({ name, value }) => handleFieldChange(name, value, index),
                                    value: el.prize,
                                })}
                                <div className="text-right">
                                    <span
                                        className="link text-danger"
                                        onClick={() => handleDeleteDetarpingPrize(index)}
                                    >
                                        Удалить надбавку растентовки
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                    <span className="link text-left" onClick={handleAddDetarpingPrize}>
                        Добавить надбавку растентовки
                    </span>
                </div>
            </div>
        );
    };

    renderIndividualPrizes = () => {
        const { config } = this.props;
        const { newIndividualPrizeLoading, newIndividualPrizeName, individualPrizes } = this.state;

        const handleAddPrize = async (event) => {
            event.preventDefault();

            if (!newIndividualPrizeName) {
                return;
            }

            this.setState({ newIndividualPrizeLoading: true });

            const response = await applyIndividualPrize({ period: this.periodFormatted, name: newIndividualPrizeName });

            if (response) {
                this.setState({
                    newIndividualPrizeName: "",
                    individualPrizes: [...individualPrizes, { id: response.entityId, name: newIndividualPrizeName }],
                });
            }

            this.setState({ newIndividualPrizeLoading: false });
        };

        const handleDeletePrize = (index) => {
            const copyIndividualPrizes = cloneDeep(individualPrizes);

            copyIndividualPrizes.splice(index, 1);

            this.setState({ individualPrizes: copyIndividualPrizes });
        };

        return (
            <div className="row form-group">
                <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                    {config.individualPrizes.label}
                </label>
                <div className="col-sm-8 col-md-9">
                    <div
                        className={cn("d-flex align-items-baseline", {
                            "form-group": individualPrizes?.length,
                            "loading loading--small": newIndividualPrizeLoading,
                        })}
                    >
                        {this.renderField({
                            inputProps: { name: "newIndividualPrizeName", placeholder: "Введите наименование премии" },
                            bWrapper: "row w-100 mr-0",
                            fieldWrapper: "col-sm-12 pr-0",
                            onChange: ({ value }) => this.setState({ newIndividualPrizeName: value }),
                            value: newIndividualPrizeName,
                        })}
                        <button className="btn btn-sm btn-brand ml-1" onClick={handleAddPrize}>
                            Добавить
                        </button>
                    </div>
                    {individualPrizes.map((el, index) => {
                        return (
                            <div key={index} className="small">
                                {index + 1}. {el.name}{" "}
                                <span className="link text-danger" onClick={() => handleDeletePrize(index)}>
                                    Удалить
                                </span>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    renderDriverIndividualPrizes = () => {
        const { config } = this.props;
        const { driverIndividualPrizes, individualPrizes } = this.state;

        const individualPrizesOptions = individualPrizes.map((el) => ({ label: el.name, value: el.id }));

        const handleFieldChange = (name, value, index) => {
            const copyDriverIndividualPrizes = driverIndividualPrizes.map((item, i) =>
                i === index ? { ...item, [name]: value } : item,
            );

            copyDriverIndividualPrizes[index][name] = value;

            this.setState({ driverIndividualPrizes: copyDriverIndividualPrizes });
        };

        const handleAddDriverPrize = () => {
            this.setState({
                driverIndividualPrizes: [
                    ...driverIndividualPrizes,
                    { driverId: null, individualPrizeId: null, prize: null },
                ],
            });
        };

        const handleDeleteDriverPrize = (index) => {
            const copyDriverIndividualPrizes = cloneDeep(driverIndividualPrizes);

            copyDriverIndividualPrizes.splice(index, 1);

            this.setState({ driverIndividualPrizes: copyDriverIndividualPrizes });
        };

        return (
            <div className="row form-group">
                <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left">
                    {config.driverIndividualPrizes.label}
                </label>
                <div className="col-sm-8 col-md-9 col-form-label col-form-label-sm">
                    {driverIndividualPrizes.map((el, index) => {
                        return (
                            <div key={index}>
                                <div className="form-group text-muted">Премия №{index + 1}</div>
                                {this.renderSelect({
                                    ...config.driverIndividualPrizes.config.driverId,
                                    onChange: ({ name, value }) => handleFieldChange(name, value, index),
                                    value: el.driverId,
                                })}
                                {this.renderSelect({
                                    ...config.driverIndividualPrizes.config.individualPrizeId,
                                    options: individualPrizesOptions,
                                    onChange: ({ name, value }) => handleFieldChange(name, value, index),
                                    value: el.individualPrizeId,
                                })}
                                {this.renderField({
                                    ...config.driverIndividualPrizes.config.prize,
                                    onChange: ({ name, value }) => handleFieldChange(name, value, index),
                                    value: el.prize,
                                })}
                                <div className="text-right">
                                    <span className="link text-danger" onClick={() => handleDeleteDriverPrize(index)}>
                                        Удалить премию
                                    </span>
                                </div>
                            </div>
                        );
                    })}
                    <span className="link text-left" onClick={handleAddDriverPrize}>
                        Добавить премию
                    </span>
                </div>
            </div>
        );
    };

    render() {
        const { config } = this.props;
        const { isValid, isLoading, ...data } = this.state;

        if (isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="absolute-center" />
                </div>
            );
        }

        const cname = cn("book-form__body", { "book-form__body--invalid": !isValid });

        return (
            <form className={cname} onSubmit={this.onSubmit}>
                {this.renderField(config.baseSalary)}
                {this.renderSelect(config.mileageType)}
                {this.renderField(config.rate)}
                {data.mileageType === driverSalaryMileageTypesEnum.ActiveAndEmpty &&
                    this.renderField({ ...config.secondaryRate, validators: [requiredField], required: true })}
                {this.renderField(config.lowMileageMultiplier)}
                {this.renderField(config.lowMileageThreshold)}
                {this.renderField(config.dailyIncome)}
                {this.renderField(config.travelDailyIncome)}
                {this.renderField(config.interBidsIdleCost)}
                {this.renderField(config.loadIdleCost)}
                {this.renderField(config.unloadIdleCost)}
                {this.renderDetarpingPrizes()}
                {this.renderIndividualPrizes()}
                {this.renderDriverIndividualPrizes()}
                <div className="mt-3 float-right">
                    <div className="btn btn-sm btn-secondary mr-2" onClick={this.props.back}>
                        Отмена
                    </div>
                    <input type="submit" className="btn btn-sm btn-brand" value="Сохранить" />
                </div>
            </form>
        );
    }
}

const ConfiguredModal = (props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [formData, setFormData] = useState({});

    useEffect(() => {
        (async () => {
            const response = await getOptions({ period: props.period });

            if (response) {
                const { baseValues, individualPrizes, driverIndividualPrizes } = response;

                const formDataFormatted = {
                    ...baseValues,
                    individualPrizes,
                    driverIndividualPrizes: driverIndividualPrizes.map((el) => ({
                        ...el,
                        individualPrizeId: el.driverIndividualPrizeId,
                    })),
                };

                setFormData(formDataFormatted);
            }

            setIsLoading(false);
        })();
    }, []);

    if (isLoading) {
        return (
            <div className="loader-wrap">
                <Loader prefix="absolute-center" />
            </div>
        );
    }

    return <Form {...props} config={config} initialState={{ ...initialState, ...formData }} />;
};

const container = (Component) => {
    const mapState = (state) => ({
        enums: state.dictionaries.enums,
    });

    const mapDispatch = () => ({});

    return connect(mapState, mapDispatch)(Component);
};

export default container(ConfiguredModal);
